/* eslint-disable react/no-array-index-key */
import React, { memo } from 'react';
import PropTypes from 'prop-types';

/**
 * Molecule: QuickReplyOptionsMC
 * Renderiza las opciones de respuesta rápida para un mensaje.
 *
 * Props:
 * - options: array de objetos { title: string }
 */
const QuickReplyOptionsMC = memo(({ options }) => {
  if (!options?.length) return null;
  return (
    <>
      {options.map((option, index) => (
        <div
          key={`list-option-${index}`}
          className="tw-bg-white tw-rounded-[6px] tw-text-[#3CAAE1] tw-px-2 tw-py-1 tw-text-center tw-mt-1"
        >
          <span>{option.title}</span>
        </div>
      ))}
    </>
  );
});

QuickReplyOptionsMC.displayName = 'QuickReplyOptionsMC';
QuickReplyOptionsMC.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired
    })
  )
};
QuickReplyOptionsMC.defaultProps = {
  options: []
};

export default QuickReplyOptionsMC;
